import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // Import App component

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <App /> 
  </React.StrictMode>
);

// Run the following command to install react-router-dom
// npm install react-router-dom

